export const genQueryString = function(obj) {
  const p = []
  Object.keys(obj).forEach(key => {
    if (obj[key] !== undefined && obj[key] !== null) {
      const value = obj[key]
      p.push(
        encodeURIComponent(key) +
          '=' +
          encodeURIComponent(
            typeof value === 'string' ? value : JSON.stringify(value),
          ),
      )
    }
  })
  return p.join('&')
}
